import { InvoiceWaste } from "../../../types/invoice-waste";

export interface InvoiceWasteTotals {
  carryover: number;
  withdraw: number;
  remain: number;
  remain_pda: number;
  waste_pda: number;
  waste: number;
  transfer_in: number;
  transfer_out: number;
  defective: number;
  sell: number;
  sell_pda: number;
  should_withdraw: number;
}

const EMPTY_TOTALS: InvoiceWasteTotals = {
  carryover: 0,
  withdraw: 0,
  remain: 0,
  remain_pda: 0,
  waste_pda: 0,
  waste: 0,
  transfer_in: 0,
  transfer_out: 0,
  defective: 0,
  sell: 0,
  sell_pda: 0,
  should_withdraw: 0,
};

/** A blank cell ("-") is a quantity of zero, not a NaN. */
const qty = (value: number | null | undefined) => Number(value ?? 0) || 0;

/**
 * Column totals for the ใบจ่ายสินค้า table.
 *
 * Each total applies the SAME fallback chain the cell above it renders — ยกมา falls back
 * นับจริง → ระบบ → checkin, เบิก falls back นับจริง → ระบบ — so the row adds up the figures
 * actually on screen. Summing the raw columns instead would quietly total a different
 * number from the one the reader is checking.
 *
 * ค่าปรับ is deliberately absent. It is not a column sum: the deduction is netted per
 * PRICE GROUP and only the shortfalls are charged, so adding the per-row `fine` values
 * would overstate it. That figure comes from the invoice-waste-summary endpoint.
 */
export function sumInvoiceWasteColumns(
  rows: InvoiceWaste[] | undefined,
): InvoiceWasteTotals {
  if (!rows || rows.length === 0) return { ...EMPTY_TOTALS };

  return rows.reduce<InvoiceWasteTotals>(
    (totals, row) => ({
      carryover:
        totals.carryover +
        qty(row.actual_carryover_qty ?? row.receive_carryover_qty ?? row.transfer_qty),
      withdraw:
        totals.withdraw + qty(row.actual_withdraw_qty ?? row.receive_withdraw_qty),
      remain: totals.remain + qty(row.actual_remain_qty),
      remain_pda: totals.remain_pda + qty(row.receive_remain_qty),
      waste_pda: totals.waste_pda + qty(row.receive_waste_qty),
      waste: totals.waste + qty(row.actual_waste_qty),
      transfer_in: totals.transfer_in + qty(row.transfer_in),
      transfer_out: totals.transfer_out + qty(row.transfer_out),
      defective: totals.defective + qty(row.defective),
      sell: totals.sell + qty(row.actual_sell_qty),
      sell_pda: totals.sell_pda + qty(row.sell_pda_qty),
      should_withdraw: totals.should_withdraw + qty(row.should_withdraw_qty),
    }),
    { ...EMPTY_TOTALS },
  );
}
